/**
 * SkinVault — Sticky Add-to-Cart Bar (SkinCeuticals-style)
 * ----------------------------------------------------------------
 * Paste this into Shopify Admin → Online Store → Themes → Edit Code
 * → Add to theme.liquid (before </body>) wrapped in <script> tags,
 * OR add as a custom JS asset and include it in the theme.
 *
 * Behavior:
 *   Sticky bar (all viewports):
 *   1. Shows when the main Add to Cart is not visible
 *   2. Hides smoothly when the user scrolls the main Add to Cart into view
 *   3. Reappears when the user scrolls past the main Add to Cart
 *   4. Displays dynamic pricing: $220 × qty = total on the button
 *
 *   Main product page (all devices):
 *   5. Replaces "Add to Cart" text with "$price — Add to Cart"
 *   6. Price updates dynamically when quantity changes
 */

(function () {
  'use strict';

  // --- Sticky Add-to-Cart bar (mobile + tablet + desktop) ---
  function init() {

    var stickyBar = document.querySelector('.add-to-cart-sticky.cart-sticky-bottom');
    var mainAddToCart = document.querySelector('#add-to-cart');
    if (!stickyBar || !mainAddToCart) return;

    // --- 1. Force the quantity + button wrapper visible ---
    // The theme hides .wrap-quantity-add-cart with high-specificity CSS,
    // so we must override with inline styles.
    var wrapQty = stickyBar.querySelector('.wrap-quantity-add-cart');
    if (wrapQty) {
      wrapQty.style.setProperty('display', 'flex', 'important');
      wrapQty.style.setProperty('align-items', 'center', 'important');
      wrapQty.style.setProperty('justify-content', 'center', 'important');
      wrapQty.style.setProperty('gap', '0', 'important');
      wrapQty.style.setProperty('list-style', 'none', 'important');
      wrapQty.style.setProperty('padding', '0', 'important');
      wrapQty.style.setProperty('margin', '0', 'important');
      wrapQty.style.setProperty('width', 'auto', 'important');
    }

    // --- 2. Dynamic pricing on the button ---
    var stickyBtn = stickyBar.querySelector('.sticky-add-to-cart .add-to-cart');
    var stickyQtyInput = stickyBar.querySelector('.item-quantity');

    function getUnitPrice() {
      var el = document.querySelector('.product-price .price') || document.querySelector('.product-price');
      var text = el ? el.textContent.replace(/[^0-9.]/g, '') : '0';
      return parseFloat(text) || 0;
    }

    function updateButtonPrice() {
      if (!stickyBtn || !stickyQtyInput) return;
      // If the main ATC is disabled (sold-out variant), mirror that state
      if (mainAddToCart && mainAddToCart.disabled) {
        stickyBtn.textContent = 'Sold Out';
        stickyBtn.disabled = true;
        stickyBtn.classList.add('sv-sold-out');
        return;
      }
      stickyBtn.disabled = false;
      stickyBtn.classList.remove('sv-sold-out');
      var qty = parseInt(stickyQtyInput.value, 10) || 1;
      var total = getUnitPrice() * qty;
      var formatted = (total % 1 === 0) ? '$' + total : '$' + total.toFixed(2);
      stickyBtn.textContent = formatted + ' \u2014 Add to Cart';
    }

    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('input', updateButtonPrice);
      stickyQtyInput.addEventListener('change', updateButtonPrice);
      // Poll to catch theme JS programmatic value changes
      setInterval(updateButtonPrice, 300);
    }

    // Initial price
    updateButtonPrice();

    // --- 2b. Enforce quantity limit on sticky bar ---
    // Clamp the qty input so + button can't go past max, and block ATC if over.
    if (stickyQtyInput) {
      // Clamp value whenever it changes (catches the + button)
      function clampStickyQty() {
        var maxAttr = stickyQtyInput.getAttribute('max');
        if (!maxAttr) return;
        var maxQty = parseInt(maxAttr, 10);
        var currentQty = parseInt(stickyQtyInput.value, 10) || 1;
        if (currentQty > maxQty) {
          stickyQtyInput.value = maxQty;
          // Show a brief error below the sticky bar
          showStickyError(maxQty);
        }
      }
      stickyQtyInput.addEventListener('input', clampStickyQty);
      stickyQtyInput.addEventListener('change', clampStickyQty);

      // Also poll to catch theme JS programmatic changes
      setInterval(clampStickyQty, 300);
    }

    // Show error message below sticky bar (only one at a time, auto-hide)
    var stickyErrorEl = null;
    var stickyErrorTimer = null;
    function showStickyError(maxQty) {
      if (!stickyErrorEl) {
        stickyErrorEl = document.createElement('div');
        stickyErrorEl.className = 'sv-sticky-error';
        stickyBar.parentNode.insertBefore(stickyErrorEl, stickyBar);
      }
      stickyErrorEl.textContent = 'Sorry! Maximum of ' + maxQty + ' per purchase.';
      stickyErrorEl.style.display = 'block';
      // Auto-hide after 3 seconds
      clearTimeout(stickyErrorTimer);
      stickyErrorTimer = setTimeout(function () {
        if (stickyErrorEl) stickyErrorEl.style.display = 'none';
      }, 3000);
    }

    // Block ATC click if somehow still over max
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        var maxAttr = stickyQtyInput ? stickyQtyInput.getAttribute('max') : null;
        if (!maxAttr) return;
        var maxQty = parseInt(maxAttr, 10);
        var currentQty = parseInt(stickyQtyInput.value, 10) || 1;
        if (currentQty > maxQty) {
          e.stopImmediatePropagation();
          e.preventDefault();
          stickyQtyInput.value = maxQty;
          showStickyError(maxQty);
          return;
        }
      }, true);
    }

    // --- 3. Show/hide based on main Add to Cart visibility ---
    stickyBar.style.setProperty('display', 'flex', 'important');
    stickyBar.classList.add('sv-sticky-visible');

    function updateVisibility() {
      var rect = mainAddToCart.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var isMainVisible = rect.top < viewportHeight && rect.bottom > 0;

      if (isMainVisible) {
        stickyBar.classList.add('sv-sticky-hidden');
        stickyBar.classList.remove('sv-sticky-visible');
      } else {
        stickyBar.classList.remove('sv-sticky-hidden');
        stickyBar.classList.add('sv-sticky-visible');
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Initial visibility check
    updateVisibility();
  }

  // --- Main product page: dynamic pricing on the Add to Cart button ---
  function initMainButton() {
    var mainBtn = document.querySelector('#add-to-cart');
    var mainQty = document.querySelector('#col-main input.item-quantity');
    if (!mainBtn || !mainQty) return;

    function getMainUnitPrice() {
      var el = document.querySelector('.product-price .price') || document.querySelector('.product-price');
      var text = el ? el.textContent.replace(/[^0-9.]/g, '') : '0';
      return parseFloat(text) || 0;
    }

    function updateMainPrice() {
      // If the button is disabled (sold-out variant), show "Sold Out"
      if (mainBtn.disabled) {
        mainBtn.textContent = 'Sold Out';
        mainBtn.classList.add('sv-sold-out');
        return;
      }
      mainBtn.classList.remove('sv-sold-out');
      var qty = parseInt(mainQty.value, 10) || 1;
      var total = getMainUnitPrice() * qty;
      var formatted = (total % 1 === 0) ? '$' + total : '$' + total.toFixed(2);
      mainBtn.textContent = formatted + ' \u2014 Add to Cart';

      // Update Afterpay installment amount to reflect qty
      var ap = document.querySelector('afterpay-placement');
      if (ap) ap.setAttribute('data-amount', String(total));
    }

    mainQty.addEventListener('input', updateMainPrice);
    mainQty.addEventListener('change', updateMainPrice);
    setInterval(updateMainPrice, 300);
    updateMainPrice();
  }

  // --- Move Afterpay callout below the Add to Cart unit (mobile + desktop) ---
  function moveAfterpay() {
    var wrapQtyCart = document.querySelector('#col-main .wrap-quantity-add-cart');
    if (!wrapQtyCart) return false;

    // Find both afterpay placements on the product page
    var mobileAfterpay = document.querySelector('.product-info.d-lg-none .group-price-sale afterpay-placement');
    var desktopAfterpay = document.querySelector('.d-none.d-lg-block .group-price-sale afterpay-placement');

    // If neither exists yet (third-party script hasn't injected them), signal retry
    if (!mobileAfterpay && !desktopAfterpay) return false;

    // Move one into the form (right after the qty+button row) and hide the other.
    var toMove = mobileAfterpay || desktopAfterpay;
    if (toMove) {
      toMove.classList.add('sv-afterpay-moved');
      wrapQtyCart.parentNode.insertBefore(toMove, wrapQtyCart.nextSibling);
    }

    // Hide whichever one is left behind so we don't get duplicates
    var remaining = mobileAfterpay ? desktopAfterpay : null;
    if (remaining) {
      remaining.style.display = 'none';
    }
    return true;
  }

  // --- Move qty-limit-msg outside the flex row and deduplicate ---
  // The theme injects a NEW .qty-limit-msg on every click past the max,
  // so we move the first one below the button row and remove duplicates.
  function watchQtyLimitMsg() {
    var wrapQtyCart = document.querySelector('#col-main .wrap-quantity-add-cart');
    if (!wrapQtyCart) return;

    // Single persistent error element that we control
    var movedMsg = null;

    function tryMove() {
      // Grab all limit messages anywhere in or after the wrapper
      var allMsgs = wrapQtyCart.querySelectorAll('.qty-limit-msg');
      var parent = wrapQtyCart.parentNode;

      // Also check for any that were previously moved outside
      var outsideMsgs = parent.querySelectorAll(':scope > .qty-limit-msg');

      if (allMsgs.length === 0 && outsideMsgs.length === 0) return;

      // If we don't have a moved message yet, create/adopt one
      if (!movedMsg) {
        movedMsg = allMsgs[0] || outsideMsgs[0];
        movedMsg.classList.add('sv-qty-limit-moved');
        // Insert right after the wrap-quantity-add-cart row
        parent.insertBefore(movedMsg, wrapQtyCart.nextSibling);
      }

      // Remove ALL duplicates (new ones the theme keeps injecting)
      allMsgs.forEach(function (msg) {
        if (msg !== movedMsg) msg.remove();
      });
      outsideMsgs.forEach(function (msg) {
        if (msg !== movedMsg) msg.remove();
      });
    }

    // Try immediately in case it already exists
    tryMove();

    // Watch for future injections (theme creates new ones on every click)
    var observer = new MutationObserver(function () { tryMove(); });
    observer.observe(wrapQtyCart, { childList: true, subtree: true });
    // Also watch the parent in case theme inserts siblings
    observer.observe(wrapQtyCart.parentNode, { childList: true });
  }

  // --- Backorder info banner -------------------------------------------------------
  // If the product title contains "[Backorder Ships In X Days]", strip it from
  // the title / breadcrumb / page <title> and render a cream info banner above
  // the Add to Cart area.
  // -------------------------------------------------------------------------------
  function initBackorderNotice() {
    var BACKORDER_REGEX = /\s*\[Backorder\s+Ships\s+In\s+(\d+\+?\s*Days?)\]/i;

    // 1. Strip from all H1 titles and extract the number
    var allH1 = document.querySelectorAll('h1.page-heading');
    var shippingNum = '';
    allH1.forEach(function (h1) {
      var match = h1.textContent.match(BACKORDER_REGEX);
      if (match) {
        shippingNum = match[1].replace(/\s*days?/i, '').replace(/\+/, ''); // "7+" → "7"
        h1.textContent = h1.textContent.replace(BACKORDER_REGEX, '');
      }
    });
    if (!shippingNum) return; // not a backorder product — bail out

    // 2. Strip from breadcrumb text nodes
    var breadcrumbItems = document.querySelectorAll('.breadcrumb li');
    breadcrumbItems.forEach(function (li) {
      var walk = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walk.nextNode())) {
        if (BACKORDER_REGEX.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(BACKORDER_REGEX, '');
        }
      }
    });

    // 3. Fix page <title>
    document.title = document.title.replace(BACKORDER_REGEX, '');

    // 4. Cream info banner above the ATC button area
    if (!document.querySelector('.sv-backorder-banner')) {
      var atcWrap = document.querySelector('.wrap-quantity-add-cart');
      if (atcWrap) {
        var banner = document.createElement('div');
        banner.className = 'sv-backorder-banner';
        banner.innerHTML =
          '<div class="sv-backorder-banner-inner">' +
            '<span class="sv-backorder-banner-icon">&#128230;</span>' +
            '<div class="sv-backorder-banner-text">' +
              '<strong>This item is on its way to us</strong>' +
              '<span>Order now to secure yours \u2014 we\u2019ll ship it as soon as it arrives, typically in about ' + shippingNum + ' days.</span>' +
            '</div>' +
          '</div>';
        atcWrap.parentNode.insertBefore(banner, atcWrap);
      }
    }
  }

  // --- "In Stock" banner for non-backorder products ----------------------------
  // Shows a green "In Stock — Ready to Ship" notice above the ATC button on
  // every product page that does NOT have a [Backorder] tag in the title.
  // Hides automatically when a sold-out variant is selected.
  function initInStockNotice() {
    // Skip if a backorder banner already exists (initBackorderNotice ran first)
    if (document.querySelector('.sv-backorder-banner')) return;
    // Skip if already inserted
    if (document.querySelector('.sv-instock-banner')) return;
    // Only on product pages
    if (!document.body.classList.contains('templateProduct')) return;

    // Use the MAIN product ATC button (#add-to-cart) — not .add-to-cart which
    // may match related-product buttons
    var mainAtcBtn = document.getElementById('add-to-cart');

    // If the product is fully sold out from the start, skip entirely
    if (mainAtcBtn && (mainAtcBtn.disabled || mainAtcBtn.classList.contains('sold-out'))) return;

    // Find .wrap-quantity-add-cart ONLY inside the main product area (not the sticky bar)
    var productWrapper = document.querySelector('.product-content-wrapper');
    var atcWrap = productWrapper
      ? productWrapper.querySelector('.wrap-quantity-add-cart')
      : null;

    // Fallback: if there's no wrap in the product area, don't inject
    // (avoids placing the banner inside the sticky bar)
    if (!atcWrap) return;

    var banner = document.createElement('div');
    banner.className = 'sv-instock-banner';
    banner.innerHTML =
      '<div class="sv-instock-banner-inner">' +
        '<span class="sv-instock-banner-icon">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3a7d44" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M20 6L9 17l-5-5"/>' +
          '</svg>' +
        '</span>' +
        '<div class="sv-instock-banner-text">' +
          '<strong>In Stock \u2014 Ready to Ship</strong>' +
        '</div>' +
      '</div>';
    atcWrap.parentNode.insertBefore(banner, atcWrap);

    // Watch MAIN ATC button for sold-out state changes (variant switches)
    if (mainAtcBtn) {
      function toggleBanner() {
        var isSoldOut = mainAtcBtn.classList.contains('sv-sold-out') ||
                        mainAtcBtn.classList.contains('sold-out') ||
                        mainAtcBtn.disabled;
        banner.style.display = isSoldOut ? 'none' : '';
      }
      // Initial check
      toggleBanner();
      // Observe class and attribute changes on the main ATC button
      var observer = new MutationObserver(toggleBanner);
      observer.observe(mainAtcBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });
    }
  }

  // --- Collection pages: strip backorder text from product card titles -----------
  function cleanCollectionCards() {
    var BACKORDER_REGEX = /\s*\[Backorder\s+Ships\s+In\s+\d+\+?\s*Days?\]/gi;
    var cardTitles = document.querySelectorAll('h5.product-name a');
    cardTitles.forEach(function (a) {
      if (BACKORDER_REGEX.test(a.textContent)) {
        a.textContent = a.textContent.replace(BACKORDER_REGEX, '');
      }
    });
  }

  // --- SkinCeuticals trust box (authorized retailer) ---------------------------
  // Only on SkinCeuticals product pages. Inserts a trust badge below "More
  // payment options" linking to the official SkinCeuticals authorized retailer page.
  // -------------------------------------------------------------------------------
  function initSkinCeuticalsTrust() {
    var url = window.location.href.toLowerCase();
    var breadcrumbs = document.querySelector('.breadcrumb');
    var isSC = /skinceuticals/i.test(url) ||
               (breadcrumbs && /skinceuticals/i.test(breadcrumbs.textContent));
    if (!isSC) return;
    if (document.querySelector('.sv-trust-box')) return;

    var shopifyPayBtn = document.querySelector('.shopify-payment-button');
    if (!shopifyPayBtn) return;

    var trustBox = document.createElement('div');
    trustBox.className = 'sv-trust-box';
    trustBox.innerHTML =
      '<div class="sv-trust-box-inner">' +
        '<div class="sv-trust-row">' +
          '<div class="sv-trust-item">' +
            '<svg class="sv-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>' +
            '<div class="sv-trust-text">' +
              '<strong>Authorized Retailer</strong>' +
              '<span>Verified by SkinCeuticals</span>' +
            '</div>' +
          '</div>' +
          '<div class="sv-trust-item">' +
            '<svg class="sv-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>' +
            '<div class="sv-trust-text">' +
              '<strong>100% Authentic</strong>' +
              '<span>Guaranteed genuine</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<a class="sv-trust-link" href="https://www.skinceuticals.ca/en_CA/authorized-retailers/authorized-retailers.html" target="_blank" rel="noopener">' +
          'Verify us on SkinCeuticals.ca \u2192' +
        '</a>' +
      '</div>';

    shopifyPayBtn.parentNode.insertBefore(trustBox, shopifyPayBtn.nextSibling);
  }

  // --- Info card: replaces the emoji callout text (shipping / gift / Canadian) ---
  // Hides the original fomo-content block and injects a clean, icon-driven card
  // into the same parent as the trust box so widths match.
  // -------------------------------------------------------------------------------
  function initInfoCard() {
    if (document.getElementById('sv-info-card')) return;
    var fomoContent = document.querySelector('.fomo-content.text-left');
    if (!fomoContent) return;

    fomoContent.style.display = 'none';

    var card = document.createElement('div');
    card.id = 'sv-info-card';
    card.innerHTML =
      '<div class="sv-info-row">' +
        '<div class="sv-info-icon">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M5 18H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10l4 4v7a1 1 0 0 1-1 1h-2"/>' +
            '<circle cx="7.5" cy="18" r="2"/>' +
            '<circle cx="14.5" cy="18" r="2"/>' +
            '<path d="M16 6h4l3 3v5a1 1 0 0 1-1 1h-1"/>' +
          '</svg>' +
        '</div>' +
        '<div class="sv-info-text">' +
          '<span class="sv-info-label">Free Shipping</span>' +
          '<span class="sv-info-detail">On all orders $99+ \u00a0\u00b7\u00a0 <a href="/policies/shipping-policy">Shipping Details</a></span>' +
        '</div>' +
      '</div>' +
      '<div class="sv-info-divider"></div>' +
      '<div class="sv-info-row">' +
        '<div class="sv-info-icon">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M20 12v10H4V12"/>' +
            '<path d="M2 7h20v5H2z"/>' +
            '<path d="M12 22V7"/>' +
            '<path d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7z"/>' +
            '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
          '</svg>' +
        '</div>' +
        '<div class="sv-info-text">' +
          '<span class="sv-info-label">Free Gift with $750+ Purchase</span>' +
          '<span class="sv-info-detail">Vivier Vitamin C Scrub, a $60 value</span>' +
        '</div>' +
      '</div>' +
      '<div class="sv-info-divider"></div>' +
      '<div class="sv-info-row">' +
        '<div class="sv-info-icon">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 2C9.5 2 7 4 7 7.5c0 3 2.5 6.5 5 10.5 2.5-4 5-7.5 5-10.5C17 4 14.5 2 12 2z"/>' +
            '<path d="M10.5 7.5L11.5 5.5 12.5 7.5 14.5 7.5 13 8.8 13.5 10.5 12 9.5 10.5 10.5 11 8.8 9.5 7.5z"/>' +
          '</svg>' +
        '</div>' +
        '<div class="sv-info-text">' +
          '<span class="sv-info-label">Canadian Owned &amp; Operated</span>' +
          '<span class="sv-info-detail">All prices in CAD \u00a0\u00b7\u00a0 Ships from Canada \u00a0\u00b7\u00a0 No duties</span>' +
        '</div>' +
      '</div>';

    // Hide the original fomo-header wrapper
    var fomoHeader = fomoContent.closest('.fomo-header');
    if (fomoHeader) fomoHeader.style.display = 'none';

    // Place after trust box (SkinCeuticals pages) or after .shopify-payment-button
    // (all other pages). This keeps the card inside product-form and outside
    // product-sub-action so it stays visible on mobile/tablet.
    var trustBox = document.querySelector('.sv-trust-box');
    var shopifyPayBtn = document.querySelector('.shopify-payment-button');
    if (trustBox) {
      trustBox.parentElement.insertBefore(card, trustBox.nextElementSibling);
    } else if (shopifyPayBtn) {
      shopifyPayBtn.parentElement.insertBefore(card, shopifyPayBtn.nextSibling);
    } else {
      fomoContent.parentElement.insertBefore(card, fomoContent.nextSibling);
    }
  }

  // --- Bidirectional quantity sync between main ATC and sticky bar ---
  // Keeps both qty inputs in lockstep. Uses a guard flag to prevent
  // infinite event loops (A changes → B changes → A changes …).
  function syncQuantities() {
    var mainQty = document.querySelector('#col-main input.item-quantity');
    var stickyBar = document.querySelector('.add-to-cart-sticky.cart-sticky-bottom');
    var stickyQty = stickyBar ? stickyBar.querySelector('.item-quantity') : null;
    if (!mainQty || !stickyQty) return;

    var syncing = false;

    function syncToSticky() {
      if (syncing) return;
      syncing = true;
      stickyQty.value = mainQty.value;
      // Fire change event so sticky bar price updates
      stickyQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }

    function syncToMain() {
      if (syncing) return;
      syncing = true;
      mainQty.value = stickyQty.value;
      // Fire change event so main price + Afterpay update
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }

    mainQty.addEventListener('input', syncToSticky);
    mainQty.addEventListener('change', syncToSticky);
    stickyQty.addEventListener('input', syncToMain);
    stickyQty.addEventListener('change', syncToMain);

    // Also poll to catch programmatic changes from +/- buttons in the theme
    var lastMainVal = mainQty.value;
    var lastStickyVal = stickyQty.value;
    setInterval(function () {
      if (syncing) return;
      if (mainQty.value !== lastMainVal) {
        lastMainVal = mainQty.value;
        if (stickyQty.value !== mainQty.value) {
          syncing = true;
          stickyQty.value = mainQty.value;
          syncing = false;
        }
        lastStickyVal = stickyQty.value;
      } else if (stickyQty.value !== lastStickyVal) {
        lastStickyVal = stickyQty.value;
        if (mainQty.value !== stickyQty.value) {
          syncing = true;
          mainQty.value = stickyQty.value;
          syncing = false;
        }
        lastMainVal = mainQty.value;
      }
    }, 250);
  }

  // Run all initialisers. Afterpay elements may not exist yet (third-party
  // script loads async), so we poll for them a few times after DOM ready.
  // --- Fix SuperZoom lightbox on related-product images ---
  // The SPZ zoom app attaches a lightbox to every img.spzgrhsince on the page,
  // which breaks click-through on the related-products carousel. We remove its
  // class + data-fancybox attributes from that section so links work normally.
  function fixRelatedProductZoom() {
    function clean() {
      var imgs = document.querySelectorAll(
        '.related-items img.spzgrhsince, .related-carousel img.spzgrhsince'
      );
      imgs.forEach(function (img) { img.classList.remove('spzgrhsince'); });

      var fbLinks = document.querySelectorAll(
        '.related-items [data-fancybox], .related-carousel [data-fancybox]'
      );
      fbLinks.forEach(function (el) {
        el.removeAttribute('data-fancybox');
        el.removeAttribute('data-thumb');
      });
      return imgs.length;
    }

    // Run immediately + poll a few times (the zoom app may init after us)
    clean();
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      clean();
      if (attempts >= 10) clearInterval(poll);
    }, 500);
  }

  // --- Product image gallery: thumbnails + lightbox (all viewports) --------
  // Replaces the theme's native thumbnail strip with a cleaner one.
  // When slick is NOT active (desktop + tablet): hides stacked images, shows
  //   one at a time, thumbnail switching + Fancybox lightbox on click.
  // When slick IS active (small mobile): controls slider via slickGoTo,
  //   syncs thumb highlights on swipe.
  // Native .slider-filter thumbnails are always hidden via CSS.
  // -------------------------------------------------------------------------
  function initProductGallery() {
    if (!document.body.classList.contains('templateProduct')) return;
    // Skip if already initialised (prevents duplicate thumb strips)
    if (document.querySelector('.sv-thumb-strip')) return;

    var slideMain = document.getElementById('slide--main');
    if (!slideMain) return;

    var $slideMain = window.jQuery ? jQuery(slideMain) : null;
    var isSlick = slideMain.classList.contains('slick-initialized');

    // On mobile/tablet the theme initialises slick AFTER DOMContentLoaded.
    // If the viewport is narrow but slick isn't ready yet, retry up to 3 s.
    if (!isSlick && window.innerWidth < 992) {
      if (!initProductGallery._retries) initProductGallery._retries = 0;
      if (initProductGallery._retries < 15) {
        initProductGallery._retries++;
        setTimeout(initProductGallery, 200);
        return;
      }
      // After 3 s give up and proceed without slick (tablet fallback)
    }

    // Get items — slick wraps them, so look in the right place
    var items;
    if (isSlick) {
      var slickTrack = slideMain.querySelector('.slick-track');
      items = slickTrack
        ? slickTrack.querySelectorAll(':scope > .slick-slide:not(.slick-cloned) .item')
        : slideMain.querySelectorAll(':scope > .item');
    } else {
      items = slideMain.querySelectorAll(':scope > .item');
    }
    if (items.length <= 1) return;

    // Collect image sources
    var allImages = [];
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (img) {
        allImages.push({
          src: img.src,
          thumb: img.src.replace('_2048x2048', '_320x320')
        });
      }
    });
    if (allImages.length <= 1) return;

    // Hide native thumbnail strip (CSS also does this, belt-and-suspenders)
    var nativeFilter = document.querySelector('.slider-filter');
    if (nativeFilter) nativeFilter.style.display = 'none';

    var currentIndex = 0;

    // --- Fancybox lightbox on image tap/click (all viewports) ---
    function openLightbox() {
      var fbItems = allImages.map(function (img) {
        return { src: img.src, type: 'image' };
      });
      jQuery.fancybox.open(fbItems, {
        loop: true,
        buttons: ['close'],
        animationEffect: 'fade',
        transitionEffect: 'fade'
      }, currentIndex);
    }

    if (!isSlick) {
      // --- Non-slick mode (desktop + tablet): manual show/hide ---
      var directItems = slideMain.querySelectorAll(':scope > .item');

      // Hide all items after the first
      for (var i = 1; i < directItems.length; i++) {
        directItems[i].style.display = 'none';
      }

      // Disable jQuery zoom to prevent conflicts
      if (window.jQuery) {
        directItems.forEach(function (item) {
          var z = item.querySelector('.img-zoom');
          if (z && jQuery(z).data('zoom')) {
            try { jQuery(z).trigger('zoom.destroy'); } catch (e) {}
          }
        });
      }

      // Click main image -> open lightbox
      directItems.forEach(function (item) {
        item.style.cursor = 'zoom-in';
        item.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openLightbox();
        });
      });
    } else {
      // --- Slick mode (mobile): tap active slide -> open lightbox ---

      // Neutralise the SuperZoom / SPZ app which hijacks all image clicks.
      // SPZ may load after us, so run cleanup now AND again after a delay.
      function neutraliseSPZ() {
        // Strip the SPZ class so it doesn't re-attach handlers
        slideMain.querySelectorAll('img.spzgrhsince').forEach(function (img) {
          img.classList.remove('spzgrhsince');
        });
        // Remove SPZ lightbox anchor wrappers
        slideMain.querySelectorAll('a.grHub_spz_supper_advance_lightbox, a[class*="grHub_spz"]').forEach(function (a) {
          while (a.firstChild) a.parentNode.insertBefore(a.firstChild, a);
          a.parentNode.removeChild(a);
        });
        // Remove any SPZ-created Fancybox containers
        document.querySelectorAll('.fancybox-container').forEach(function (fb) {
          if (fb.querySelector('[class*="spz"]') || fb.querySelector('[class*="grHub"]')) {
            fb.parentNode.removeChild(fb);
          }
        });
      }
      neutraliseSPZ();
      // Re-run after SPZ likely finishes initialising
      setTimeout(neutraliseSPZ, 1500);
      setTimeout(neutraliseSPZ, 3500);

      // Capture-phase document listener for main image taps.
      // This fires before slick or SPZ can intercept.
      var _svImgTouchX = 0, _svImgTouchY = 0;
      document.addEventListener('touchstart', function (e) {
        if (e.target.closest('#slide--main .slick-slide')) {
          _svImgTouchX = e.touches[0].clientX;
          _svImgTouchY = e.touches[0].clientY;
        }
      }, true);
      document.addEventListener('touchend', function (e) {
        if (!e.target.closest('#slide--main .slick-slide')) return;
        // Ignore if it was a thumb tap (handled separately)
        if (e.target.closest('.sv-thumb')) return;
        var t = e.changedTouches[0];
        if (Math.abs(t.clientX - _svImgTouchX) > 10 ||
            Math.abs(t.clientY - _svImgTouchY) > 10) return;
        e.preventDefault();
        e.stopPropagation();
        openLightbox();
      }, true);

      // Also keep click handler for desktop emulation / accessibility
      var $slickList = jQuery(slideMain).find('.slick-list');
      if ($slickList.length) {
        $slickList.on('click', function () { openLightbox(); });
      }

      // Set cursor on slides
      slideMain.querySelectorAll('.slick-slide .item').forEach(function (item) {
        item.style.cursor = 'zoom-in';
      });
    }

    // --- Build thumbnail strip (all viewports) ---
    var thumbStrip = document.createElement('div');
    thumbStrip.className = 'sv-thumb-strip';

    // Shared handler to navigate to a specific thumb index.
    // IMPORTANT: check slick state LIVE (not from closure) because our code
    // may run before slick finishes initialising on mobile.
    function goToThumb(clickedIdx) {
      currentIndex = clickedIdx;
      var slickNow = slideMain.classList.contains('slick-initialized');
      if (slickNow) {
        jQuery(slideMain).slick('slickGoTo', clickedIdx);
      } else {
        var dItems = slideMain.querySelectorAll(':scope > .item');
        dItems.forEach(function (item, i) {
          item.style.display = i === clickedIdx ? 'block' : 'none';
        });
      }
      thumbStrip.querySelectorAll('.sv-thumb').forEach(function (t, i) {
        t.classList.toggle('sv-thumb-active', i === clickedIdx);
      });
    }

    allImages.forEach(function (imgData, idx) {
      var thumb = document.createElement('div');
      thumb.className = 'sv-thumb' + (idx === 0 ? ' sv-thumb-active' : '');
      thumb.setAttribute('data-index', idx);
      // Make tappable on iOS (onclick is the most reliable mobile handler)
      thumb.setAttribute('role', 'button');
      thumb.onclick = function () {
        goToThumb(idx);
        return false;
      };

      var thumbImg = document.createElement('img');
      thumbImg.src = imgData.thumb;
      thumbImg.alt = 'Product image ' + (idx + 1);
      thumb.appendChild(thumbImg);
      thumbStrip.appendChild(thumb);
    });

    // Capture-phase document listener as a bulletproof fallback for
    // mobile taps.  Fires before any other handler can stop propagation.
    var _svThumbTouchY = 0, _svThumbTouchX = 0;
    document.addEventListener('touchstart', function (e) {
      var thumb = e.target.closest('.sv-thumb');
      if (thumb) {
        _svThumbTouchX = e.touches[0].clientX;
        _svThumbTouchY = e.touches[0].clientY;
      }
    }, true);  // capture = true
    document.addEventListener('touchend', function (e) {
      var thumb = e.target.closest('.sv-thumb');
      if (!thumb) return;
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - _svThumbTouchX) > 10 ||
          Math.abs(t.clientY - _svThumbTouchY) > 10) return;
      e.preventDefault();
      var idx = parseInt(thumb.getAttribute('data-index'));
      if (!isNaN(idx)) goToThumb(idx);
    }, true);  // capture = true

    // Insert after .slider-main-image
    var sliderMain = document.querySelector('.slider-main-image');
    if (sliderMain) {
      sliderMain.parentNode.insertBefore(thumbStrip, sliderMain.nextSibling);
    }

    // In slick mode, sync thumb highlights when user swipes.
    // Check live state because slick may have initialised after us.
    function bindSlickSync() {
      if (slideMain.classList.contains('slick-initialized')) {
        jQuery(slideMain).on('afterChange', function (event, slick, newIndex) {
          currentIndex = newIndex;
          thumbStrip.querySelectorAll('.sv-thumb').forEach(function (t, i) {
            t.classList.toggle('sv-thumb-active', i === newIndex);
          });
        });
        return true;
      }
      return false;
    }
    if (!bindSlickSync()) {
      // Retry binding until slick is ready
      var syncAttempts = 0;
      var syncPoll = setInterval(function () {
        syncAttempts++;
        if (bindSlickSync() || syncAttempts >= 15) clearInterval(syncPoll);
      }, 200);
    }
  }

  function runAll() {
    init();
    initMainButton();
    initBackorderNotice();
    initInStockNotice();
    cleanCollectionCards();
    initSkinCeuticalsTrust();
    initInfoCard();
    initProductGallery();

    // Watch for qty-limit-msg (injected dynamically by theme JS)
    watchQtyLimitMsg();

    // Bidirectional quantity sync between main ATC and sticky bar
    syncQuantities();

    // Fix SuperZoom/SPZ lightbox hijacking clicks on related product images.
    // The zoom app adds its class to ALL images on the page, including the
    // related-products carousel. We strip it so those links work normally.
    fixRelatedProductZoom();

    // Move afterpay (third-party, async)
    if (!moveAfterpay()) {
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (moveAfterpay() || attempts >= 20) clearInterval(poll);
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();